/**
 * Titre des colonnes de notre tableau.
 */
export const dossiersLocationHeader = (candidatLocataire?: boolean) => {
  let columns = [
    {
      id: "site",
      idTriable: "site",
      libelle: "Site",
      isTriable: true,
    },
    {
      id: "refLocation",
      idTriable: "reference",
      libelle: "Ref location",
      isTriable: true,
    },
    {
      id: "refMandat",
      idTriable: "bien.referenceMandat",
      libelle: "Ref mandat",
      isTriable: true,
    },
    {
      id: "NumeroLot",
      idTriable: "bien.numeroLot",
      libelle: "N° lot",
      isTriable: false,
    },
    {
      id: "ville",
      idTriable: "bien.ville",
      libelle: "Ville",
      isTriable: true,
    },
    {
      id: "adresse",
      libelle: "Adresse",
      isTriable: false,
    },
    {
      id: "loyerCharges",
      idTriable: "bien.loyerMensuel",
      libelle: "Loyer + charges",
      isTriable: true,
    },
    {
      id: "loyerMaxConseille",
      libelle: "Loyer max conseillé",
      isTriable: false,
    },
    {
      id: "locReferent",
      libelle: "Loc Référent",
      isTriable: false,
    },
    {
      id: "gli",
      libelle: "GLI",
      isTriable: false,
    },
    {
      id: "statut",
      libelle: "Statut",
      isTriable: false,
    },
  ];

  if (candidatLocataire) {
    columns.push({
      id: "type",
      libelle: "Type",
      isTriable: false,
    });
  }

  columns.push(
    {
      id: "enPlace",
      libelle: "En place",
      isTriable: false,
    },
    {
      id: "actions",
      libelle: "Actions",
      isTriable: false,
    }
  );

  return columns;
};
